import React, {Component, Fragment } from 'react';
import check from '../../../images/driverpolicy-images/check.png';
import gaslevel from '../../../images/driverpolicy-images/Gas Level.png';
import watch from '../../../images/driverpolicy-images/Watch.png';
import wifi from '../../../images/driverpolicy-images/wifi.png';


class DriverChecklist extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render(){
    const { city } = this.props;
    return(

      <Fragment>
        <div className="checklist__column--container">
            <h3><strong>Driving Checklist</strong></h3>
           <br/>
            <ul>
              <li>
                <img src={check}/>
                <a href='#damages'>Check for Damage</a>
              </li>
              <br/>
              <li>
                <img src={gaslevel}/>
                <a href='#gaslevel'>Check the Gas Level</a>
              </li>
              <br/>
              {city === 'new_york' ? (<li>
                <img src={wifi}/>
                <a href='#incorrectuse'>Get Online in VIA</a>
              </li>) : (<li>
                <img src={wifi}/>
                <a href='#incorrectuse'>Get Online in Uber</a>
              </li>)}
              <br/>
              <li>
                <img src={watch}/>
                <a href='#latereturn'>Be Back on Time</a>
              </li>
            </ul>
            <br/>
          <p>For damages, gas shortages, late drivers and any other issues,
         make sure to go to your booking in your Autzu account and click 
         on the <strong>Report Incident</strong> button.</p>
         <br/>
         <br/>
        </div>
        
      </Fragment>

    )
  }
 }

export default DriverChecklist;



// WEBPACK FOOTER //
// ./src/components/Static/DriverPolicy/DriverChecklist.js